module.exports = __webpack_public_path__ + "img/collection-weddingRingsPalladium@2x.8d450d8.webp";